import { useEffect, useState } from 'react';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import {
  ButtonBasic,
  InputDinamycPlaceholder,
  ButtonClose
} from '@lk-gtcom/ecomlab-components';
import file_icon from './img/bx-file.svg';
import plus_circle from './img/bx-plus-circle.svg';
import './ModalCreateChatBot.scss';
import { Andrey3Https, AndreyFilesHttps } from '../../../fetchUrls';
import { MoonLoader } from 'react-spinners';
import { TitlePage } from '../../TitlePage/TitlePage';
import { TextPage } from '../../TextPage/TextPage';
import { ModalComponent } from '../ModalComponent/ModalComponent';

const FileItem = ({ name = 'Нет названия', onDelete }) => {
  return (
    <div className="file-item">
      <ButtonClose
        s
        onClick={onDelete}
      />
      <img src={file_icon} className="file-item__icon" alt="file icon" />
      <p className="file-item__name">{name}</p>
    </div>
  );
};

const DropZone2 = ({ onUpload }) => {
  const handleFileUpload = (e) => {
    const uploadedFiles = Array.from(e.target.files);
    onUpload(uploadedFiles);
  };

  return (
    <label className="drop-zone-2">
      <img src={plus_circle} alt="Добавить" />
      <input
        type="file"
        multiple
        onChange={handleFileUpload}
        style={{ display: 'none' }}
      />
      <TextPage
        text='Добавить файлы'
        style={{
          textAlign: 'center'
        }}
      />
    </label>
  );
};

const ModalCreateChatBot = ({
  setIsModal,
  isEdit,
  setIsEdit,
  botId,
  setBotId,
  chatName,
  setChatName,
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const [name, setName] = useState('');
  const [files, setFiles] = useState([]);
  const [fileBot, setFileBot] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingFile, setLoadingFile] = useState(false);

  const addFileToBot = async (botId, file) => {
    if (!file) {
      console.error('Файл отсутствует');
      return;
    }

    const url = `${Andrey3Https}/bot/${String(botId)}/add-file`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: updatedHeaders,
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Ошибка добавления файла:', errorData);
      }

      const data = await response.json();
      setFileBot(data);
      fetchBotFiles(botId);
      setLoadingFile(true);
    } catch (err) {
      console.error('Ошибка запроса:', err);
      return null;
    }
  };

  const handleFileUpload = async (newFile) => {
    if (!newFile || !newFile.length) return;

    setLoadingFile(true);
    try {
      await addFileToBot(botId, newFile[0]);
    } catch (error) {
      console.error('Ошибка загрузки файла');
    } finally {
      setLoadingFile(false);
    }
  };

  const handleFileDelete = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleResetModal = () => {
    setIsEdit(false);
    setIsModal(false);
    setBotId(null);
  };

  const fetchCreateBot = () => {
    const url = `${Andrey3Https}/bot/create`;

    const body = JSON.stringify({
      bot_name: name,
    });

    fetch(url, {
      method: 'POST',
      headers,
      body,
    })
      .then((res) => {
        if (!res.ok) throw new Error('Ошибка создания чат-бота');
        return res.json();
      })
      .then((data) => {
        const { bot_id } = data;
        setBotId(bot_id);
      })
      .catch((err) => console.error(err));
  };

  const fetchBotFiles = (botId) => {
    let url;
    if (!window.location.hostname.match('localhost')) {
      url = `${Andrey3Https}/bot/${botId}/file-list`;
    } else {
      url = `${Andrey3Https}/bot/${botId}/file-list`;
    }

    fetch(url, { method: 'GET', headers })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('Error: get_tables_list request');
        }
      })
      .then((json) => {
        console.log(json, 'files');
        setFileBot(json);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (botId) {
      fetchBotFiles(botId);
    }
    return () => {
      setChatName('');
    };
  }, []);

  return (
    <ModalComponent
      onClose={e => {
        setIsEdit(false)
        setIsModal(false)
      }}
      title={!isEdit ? `Создание чат-бота` : `Редактирование чат-бота "${chatName}"`}
      right
      child={
        <div className="modal-create-chat-bot">

          <div className="modal-create-chat-bot__content">
            <div className="modal-create-chat-bot__input-box">
              <InputDinamycPlaceholder
                changeValue={chatName}
                onChange={(e) => setName(e)}
                placeholder="Название чат-бота"
                size="s"
              />
            </div>
            {botId && (
              <>
                <TitlePage
                  medium
                  title='Загруженные файлы для чат-бота'
                />

                {loadingFile ? (
                  <MoonLoader color="#22C55E" speedMultiplier={0.5} size={50} />
                ) : fileBot?.length ? (
                  fileBot.map((el, ind) => (
                    <div key={el + ind} style={{ display: 'flex', gap: '12px' }}>
                      <p>{ind + 1}</p>
                      <p>{el?.file_name}</p>
                      <p>{el?.file_uuid}</p>
                    </div>
                  ))
                ) :
                  <TextPage
                    text='Файлов пока нет'
                  />
                }

                <TitlePage
                  medium
                  title='Добавить файлы для чат-бота'
                />

                <div className="modal-create-chat-bot__files-box">
                  {files.map((file, index) => (
                    <FileItem
                      key={index}
                      name={file.name}
                      onDelete={() => handleFileDelete(index)}
                    />
                  ))}
                  <DropZone2 onUpload={handleFileUpload} />
                </div>
              </>
            )}
          </div>
          <ButtonBasic
            green
            size='56px'
            text={!botId ? 'Создать чат-бота' : 'Сохранить'}
            onClick={() => {
              !botId ? fetchCreateBot() : handleResetModal();
            }}
          />
        </div>}
    />
  );
};

export { ModalCreateChatBot };
